module.exports = __webpack_public_path__ + "static/media/iphone_14_red_plus.1d579c6c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_14_red_plus.jpeg
// module id = 2130
// module chunks = 0